import { frontendURL } from '../../../helper/URLHelper';
const FlowsListView = () => import('./FlowsListView.vue');
const FlowEditorView = () => import('./FlowEditorView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/flujos'),
      name: 'flows_list',
      component: FlowsListView,
      meta: { permissions: ['administrator'] },
    },
    {
      path: frontendURL('accounts/:accountId/flujos/nuevo'),
      name: 'flows_new',
      component: FlowEditorView,
      meta: { permissions: ['administrator'] },
    },
    {
      path: frontendURL('accounts/:accountId/flujos/:flowId'),
      name: 'flows_edit',
      component: FlowEditorView,
      meta: { permissions: ['administrator'] },
    },
  ],
};
